import { useEffect, useRef, useState } from 'react';
import ChartistGraph from 'react-chartist';
import { getDashboardHeightScale } from '../dashboardLayout';

const SECTOR_COLORS = ['#0948B3', '#F8BD7A', '#1B998B', '#404E7C', '#C83E4D', '#94A3B8'];

function TopSectorsCard(props) {
  const chartRef = useRef(null);
  const [chartSize, setChartSize] = useState(130);
  const { labels = [], series = [], totalValue = 0 } = props.chartData || {};

  useEffect(() => {
    const element = chartRef.current;
    if (!element) {
      return undefined;
    }

    const updateSize = () => {
      const { clientWidth, clientHeight } = element;
      if (clientWidth <= 0) {
        return;
      }

      const scale = getDashboardHeightScale(element);
      const gap = 12;
      const legendReserve = Math.min(clientWidth * 0.42, 72 + labels.length * 26);
      const maxByWidth = clientWidth - legendReserve - gap;
      const size = clientHeight > 80
        ? Math.min(maxByWidth, clientHeight)
        : maxByWidth;

      if (size > 0) {
        setChartSize(Math.floor(size * scale));
      }
    };

    updateSize();
    const observer = new ResizeObserver(updateSize);
    observer.observe(element);
    return () => observer.disconnect();
  }, [labels.length]);

  const options = {
    height: `${chartSize}px`,
    width: `${chartSize}px`,
    showLabel: false
  };

  return (
    <div className="col-12 col-xl-3">
      <div className="card border-light shadow-sm top-sectors-card-wrapper">
        <div className="card-header d-flex flex-row align-items-center">
          <div className="h4">Top Sectors</div>
        </div>
        <div className="card-body top-sectors-card">
          <div className="top-sectors-chart" ref={chartRef}>
            <div
              className="top-sectors-chart-pie"
              style={{ width: chartSize, height: chartSize }}
            >
              <ChartistGraph data={props.chartData} type="Pie" options={options} />
            </div>
            <ul className="top-sectors-legend list-unstyled mb-0">
              {labels.map((label, idx) => (
                <li key={`${label}-${idx}`} className="top-sectors-legend-item">
                  <span
                    className="top-sectors-legend-swatch"
                    style={{ backgroundColor: SECTOR_COLORS[idx % SECTOR_COLORS.length] }}
                  />
                  <span className="top-sectors-legend-label">
                    {label}
                    {totalValue > 0 && (
                      <span className="top-sectors-legend-percent">
                        {((series[idx] / totalValue) * 100).toFixed(1)}%
                      </span>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopSectorsCard;
